import React from "react";

export const ValidationReportContext = React.createContext({
    doSearch: null,
    parent: null,
});